import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, Send } from "lucide-react";
import api, { formatApiError } from "@/api";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";

export default function SubmitProvider() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    name: "", website: "", contact_email: "", hq_country: "", hq_city: "",
    tagline: "", description: "",
  });
  const [submitted, setSubmitted] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/providers/submit", form);
      setSubmitted(data);
    } catch (err) { toast.error(formatApiError(err)); }
  };

  if (submitted) return (
    <div className="max-w-2xl mx-auto px-4 py-24 text-center">
      <CheckCircle2 size={56} className="mx-auto text-emerald-500"/>
      <h1 className="font-display font-extrabold text-3xl mt-4">Listing submitted</h1>
      <p className="mt-3 text-slate-600">Our team will review your submission and publish it shortly.</p>
      <Link to="/" className="btn-primary mt-6 inline-flex">Return home</Link>
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div className="text-xs font-semibold uppercase tracking-widest text-slate-500">Provider submission</div>
      <h1 className="font-display font-extrabold text-3xl text-slate-900 mt-1">Submit your company</h1>
      <p className="text-sm text-slate-600 mt-2 max-w-xl">
        Add your tracking solution to Strategic Tracking. Our team will review and publish your listing.
      </p>

      <form onSubmit={submit} className="card-elevated p-8 mt-8 space-y-5" data-testid="submit-form">
        <div className="grid sm:grid-cols-2 gap-4">
          <Field label="Company name *"><Input value={form.name} onChange={(e)=>setForm({...form, name: e.target.value})} required data-testid="submit-name"/></Field>
          <Field label="Website *"><Input value={form.website} onChange={(e)=>setForm({...form, website: e.target.value})} placeholder="https://" required data-testid="submit-website"/></Field>
          <Field label="Contact email"><Input type="email" value={form.contact_email} onChange={(e)=>setForm({...form, contact_email: e.target.value})} data-testid="submit-email"/></Field>
          <Field label="HQ country"><Input value={form.hq_country} onChange={(e)=>setForm({...form, hq_country: e.target.value})} data-testid="submit-country"/></Field>
          <Field label="HQ city"><Input value={form.hq_city} onChange={(e)=>setForm({...form, hq_city: e.target.value})} data-testid="submit-city"/></Field>
        </div>
        <Field label="Tagline"><Input value={form.tagline} onChange={(e)=>setForm({...form, tagline: e.target.value})} maxLength={200} data-testid="submit-tagline"/></Field>
        <Field label="Description"><Textarea rows={5} value={form.description} onChange={(e)=>setForm({...form, description: e.target.value})} data-testid="submit-description"/></Field>
        <button type="submit" className="btn-primary w-full justify-center h-11" data-testid="submit-submit"><Send size={16}/> Submit listing</button>
      </form>
    </div>
  );
}

function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs font-semibold uppercase tracking-widest text-slate-500 mb-1.5 block">{label}</Label>
      {children}
    </div>
  );
}
